import { render, staticRenderFns } from "./AdminAccount.vue?vue&type=template&id=0a60c312&scoped=true&"
import script from "./AdminAccount.vue?vue&type=script&lang=js&"
export * from "./AdminAccount.vue?vue&type=script&lang=js&"
import style0 from "./AdminAccount.vue?vue&type=style&index=0&id=0a60c312&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a60c312",
  null
  
)

export default component.exports